import { Component, OnInit, Optional } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { QuotationDetailService } from 'src/app/services/preliminaries/quotation-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-attach-images-quotation-detail',
  templateUrl: './attach-images-quotation-detail.component.html',
  styleUrls: ['./attach-images-quotation-detail.component.scss'],
  standalone: false
})
export class AttachImagesQuotationDetailComponent implements OnInit {
  quotationSolutionModel: QuotationDetailModel = new QuotationDetailModel();
  imageUrls: SafeUrl[] = [];
  subscription: Subscription;
  previews: (SafeUrl | null)[] = [null, null, null, null];

  constructor(
    public config: DynamicDialogConfig,
    private quotationDetailService: QuotationDetailService,
    private sanitizer: DomSanitizer,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = input$?.subscribe((inputs: any) => {
      this.quotationSolutionModel = inputs.quotationSolutionModel;
    });

    await this.chargeImages();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private async buildImageUrl(imagePath: string): Promise<SafeUrl> {
    const blob = await firstValueFrom(
      this.quotationDetailService.getImageUrl(
        this.quotationSolutionModel.quotationDetailId,
        imagePath
      )
    );
    const objectURL = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  async attachImage(image: File, slotIndex: number) {
    const formData = new FormData();
    formData.append('file', image);
    try {
      this.quotationSolutionModel = await firstValueFrom(
        this.quotationDetailService.attachImage(
          this.quotationSolutionModel.quotationDetailId,
          slotIndex,
          formData
        )
      );

      this.emitQuotationSolutionModel(this.quotationSolutionModel);
    } catch (err) {
      this.toastHandlerService.showToast('error', 'Error al subir la imagen.', '');
      console.error(err);
    }
  }

  async attachImageUrl(imageUrl: string, slotIndex: number) {
    try {
      this.previews[slotIndex - 1] = imageUrl;
    } catch (err) {
      this.toastHandlerService.showToast('error', 'Error al subir la imagen.', '');
      console.error(err);
    }
  }

  async chargeImages() {
    const imagePaths = [
      this.quotationSolutionModel.image1,
      this.quotationSolutionModel.image2,
      this.quotationSolutionModel.image3,
      this.quotationSolutionModel.image4
    ];

    for (let i = 0; i < imagePaths.length; i++) {
      if (imagePaths[i]) {
        this.previews[i] = await this.buildImageUrl(imagePaths[i]!);
      }
    }
  }

  async deleteImage(slotIndex: number) {
    this.quotationSolutionModel = await firstValueFrom(
      this.quotationDetailService.deleteImage(
        this.quotationSolutionModel.quotationDetailId,
        slotIndex
      )
    );
    this.previews[slotIndex - 1] = null;
    this.emitQuotationSolutionModel(this.quotationSolutionModel);
  }

  emitQuotationSolutionModel(quotationSolutionModel: QuotationDetailModel) {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'updateQuotationSolutionModel', payload: quotationSolutionModel });
  }
}